"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tokens = require("@superlogica/foundation/tokens");

var _utils = require("@superlogica/foundation/utils");

var inputThemefication = function inputThemefication(inputColors) {
  var background = (0, _utils.parseColor)(inputColors.background);
  var primaryColor = (0, _utils.parseColor)(inputColors.primary);
  var textColor = (0, _utils.parseColor)(inputColors.textColor);
  var color = (0, _utils.parseColor)(inputColors.color);
  var dangerColor = (0, _utils.parseColor)(inputColors.danger);
  var successColor = (0, _utils.parseColor)(inputColors.success);
  var theme = {
    normal: {
      background: background,
      borderColor: color,
      color: textColor,
      label: (0, _utils.hoverColor)(color),
      hover: (0, _utils.hoverColor)(textColor)
    },
    focus: {
      color: primaryColor
    },
    danger: {
      background: background,
      color: dangerColor,
      hover: (0, _utils.hoverColor)(dangerColor)
    },
    success: {
      background: background,
      color: successColor,
      hover: (0, _utils.hoverColor)(successColor)
    },
    disabled: {
      color: _tokens.colors.neutral300,
      background: _tokens.colors.neutral50
    },
    readonly: {
      color: _tokens.colors.neutral300,
      background: _tokens.colors.neutral50
    }
  };
  return theme;
};

var _default = inputThemefication;
exports.default = _default;